import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-height: 100%;

  .header {
    h2 {
      font-family: Sora, sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #101d40;
    }

    & > p {
      font-family: Sora, sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #757575;
    }
  }
`;

export const Filtros = styled.form`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  border: 2px solid rgb(230, 239, 251);
  border-radius: 5px;
  padding: 16px;

  .campo {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 150px;
    flex: 1;

    label {
      font-family: Sora, sans-serif;
      font-size: 12px;
      font-weight: 600;
      color: #101d40;
    }

    input,
    select {
      height: 38px;
      padding: 0 10px;
      border: 1px solid #e6effb;
      border-radius: 5px;
      font-family: Sora, sans-serif;
      font-size: 14px;
      color: #101d40;
      background-color: #ffffff;

      &:focus {
        outline: none;
        border-color: #329bfc;
      }
    }
  }

  .acoes-filtro {
    display: flex;
    gap: 8px;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      height: 38px;
      padding: 0 18px;
      border-radius: 5px;
      font-family: Sora, sans-serif;
      font-weight: 600;
      font-size: 14px;
      border: none;
      cursor: pointer;
      background-color: #329bfc;
      color: #ffffff;

      &:disabled {
        background-color: rgba(0, 0, 0, 0.12);
        cursor: not-allowed;
      }
    }

    button.limpar {
      background-color: transparent;
      color: #757575;
      border: 1px solid #e6effb;
    }
  }
`;

export const ContainerList = styled.div`
  border: 2px solid rgb(230, 239, 251);
  border-radius: 5px;
  overflow-x: auto;
`;

export const TableHeader = styled.div`
  display: grid;
  column-gap: 16px;
  grid-template-columns: 110px minmax(260px, 1fr) 110px 170px 110px 130px 200px;
  padding: 16px;
  font-family: Sora, sans-serif;
  font-size: 11px;
  color: #acb3be;
  font-weight: 600;
  align-items: center;
`;

export const TableRow = styled.div`
  display: grid;
  column-gap: 16px;
  grid-template-columns: 110px minmax(260px, 1fr) 110px 170px 110px 130px 200px;
  border-top: 1px solid #e6effb;
  padding: 16px;
  align-items: center;
  background-color: #ffffff;

  p {
    font-family: Sora, sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #101d40;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .chave {
    font-size: 12px;
    color: #4f4f4f;
  }
`;

/** Emissão em duas linhas: data em cima, hora (sem segundos) embaixo. */
export const EmissaoCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  span {
    font-family: Sora, sans-serif;
    font-size: 11px;
    font-weight: 400;
    color: #7f8c8d;
    white-space: nowrap;
  }
`;

export const StatusBadge = styled.span<{ cor: 'verde' | 'vermelho' | 'amarelo' | 'cinza' }>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-family: Sora, sans-serif;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;

  ${({ cor }) => {
    switch (cor) {
      case 'verde':
        return `background-color: rgba(46, 204, 113, 0.15); color: #1e8449;`;
      case 'vermelho':
        return `background-color: rgba(231, 76, 60, 0.15); color: #c0392b;`;
      case 'amarelo':
        return `background-color: rgba(241, 196, 15, 0.2); color: #b7950b;`;
      default:
        return `background-color: rgba(149, 165, 166, 0.2); color: #7f8c8d;`;
    }
  }}
`;

/**
 * Célula de status: o badge e, para notas rejeitadas/denegadas, o motivo
 * devolvido pela SEFAZ em uma linha (clicável para abrir o detalhe).
 */
export const StatusCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;

  button.motivo {
    max-width: 100%;
    background: transparent;
    border: none;
    padding: 0;
    text-align: left;
    font-family: Sora, sans-serif;
    font-size: 11px;
    color: #c0392b;
    cursor: pointer;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    &:hover {
      text-decoration: underline;
    }
  }
`;

/** Grade rótulo/valor do modal de detalhe da rejeição. */
export const RejeicaoDetalhe = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  background-color: rgba(231, 76, 60, 0.08);
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;

  span.rotulo {
    font-family: Sora, sans-serif;
    font-size: 11px;
    font-weight: 600;
    color: #acb3be;
    margin-top: 6px;

    &:first-child {
      margin-top: 0;
    }
  }

  strong {
    font-family: Sora, sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: #101d40;
    word-break: break-word;
  }
`;

export const Acoes = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  button,
  span.copiar {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: #329bfc;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;

    &:hover {
      background-color: rgba(50, 155, 252, 0.1);
    }

    &:disabled {
      color: #c4c4c4;
      cursor: not-allowed;
      &:hover {
        background-color: transparent;
      }
    }
  }

  button.cancelar,
  button.rejeicao {
    color: #e74c3c;

    &:hover {
      background-color: rgba(231, 76, 60, 0.1);
    }
  }
`;

export const Paginacao = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 4px;

  span {
    font-family: Sora, sans-serif;
    font-size: 13px;
    color: #757575;
  }

  button {
    height: 32px;
    padding: 0 14px;
    border-radius: 5px;
    border: 1px solid #e6effb;
    background-color: #ffffff;
    font-family: Sora, sans-serif;
    font-weight: 600;
    font-size: 13px;
    color: #329bfc;
    cursor: pointer;

    &:disabled {
      color: #c4c4c4;
      cursor: not-allowed;
    }
  }
`;

export const EmptyState = styled.div`
  padding: 40px;
  text-align: center;
  font-family: Sora, sans-serif;
  font-size: 14px;
  color: #757575;
`;

/** Modal de cancelamento (Story 4-1 / T4.2). Centralizado sobre o MUI Modal. */
export const ModalBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 440px;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
  outline: none;
  font-family: Sora, sans-serif;

  h3 {
    margin: 0 0 12px;
    color: #101d40;
    font-size: 18px;
  }

  p.nota {
    color: #101d40;
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 4px;
  }

  p.chave {
    color: #757575;
    font-size: 12px;
    word-break: break-all;
    margin: 0 0 12px;
  }

  p.aviso {
    color: #757575;
    font-size: 13px;
    margin: 0 0 12px;
  }

  textarea {
    width: 100%;
    border: 1px solid #e6effb;
    border-radius: 6px;
    padding: 10px;
    font-family: Sora, sans-serif;
    font-size: 14px;
    color: #101d40;
    resize: vertical;

    &:focus {
      outline: none;
      border-color: #329bfc;
    }
  }

  span.contador {
    display: block;
    text-align: right;
    color: #757575;
    font-size: 12px;
    margin-top: 4px;
  }

  div.acoes {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;

    button {
      border: none;
      border-radius: 6px;
      padding: 10px 18px;
      font-family: Sora, sans-serif;
      font-size: 14px;
      cursor: pointer;

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    button.voltar {
      background-color: #ffffff;
      border: 1px solid #e6effb;
      color: #101d40;
    }

    button.confirmar {
      background-color: #d62828;
      color: #ffffff;
    }

    button.primario {
      background-color: #329bfc;
      color: #ffffff;
    }
  }
`;
